import {
  TERRITORY_SUCCESS,
  TERRITORY_PENDING,
  TERRITORY_FAIL,
  ADD_TERRITORY_SUCCESS,
  ADD_TERRITORY_PENDING,
  ADD_TERRITORY_FAIL,
  UPDATE_TERRITORY_SUCCESS,
  UPDATE_TERRITORY_PENDING,
  UPDATE_TERRITORY_FAIL,
  SET_MESSAGE,
} from "../types";
import { toast } from "react-toastify";
import UserService from "../../services/user.service";

export const getTerritories = (pageNumber, pageSize, cityId, isActive, searchQuery) => async (dispatch) => {
  dispatch({
    type: TERRITORY_PENDING,
    payload: { territories: "isLoading" },
  });
  return await UserService.getTerritories(pageNumber, pageSize, cityId, isActive, searchQuery)
    .then(
      (data) => {
        data.data.status
          ? dispatch({
              type: TERRITORY_SUCCESS,
              payload: { territories: data.data },
            })
          : dispatch({ type: TERRITORY_FAIL });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({ type: TERRITORY_FAIL });
        dispatch({ type: SET_MESSAGE, payload: message });
        return Promise.reject();
      }
    )
    .catch((error) => {
      console.log(error);
    });
};

export const addTerritory = (body) => async (dispatch) => {
  dispatch({
    type: ADD_TERRITORY_PENDING,
    payload: { addTerritory: "isLoading" },
  });
  return await UserService.addTerritory(body)
    .then(
      (data) => {
        data.data.status
          ? toast.success(data.data.message, { autoClose: 2000 })
          : toast.error(data.data.message, { autoClose: 2000 });
        data.data.status
          ? dispatch({
              type: ADD_TERRITORY_SUCCESS,
              payload: { addTerritory: data.data.status },
            })
          : dispatch({
              type: ADD_TERRITORY_FAIL,
              payload: { addTerritory: data.data.status },
            });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({ type: ADD_TERRITORY_FAIL });
        dispatch({ type: SET_MESSAGE, payload: message });
        return Promise.reject();
      }
    )
    .catch((error) => {
      console.log(error);
    });
};

export const updateTerritory = (body) => async (dispatch) => {
  dispatch({
    type: UPDATE_TERRITORY_PENDING,
    payload: { updateTerritory: "isLoading" },
  });
  return await UserService.updateTerritory(body)
    .then(
      (data) => {
        data.data.status
          ? toast.success(data.data.message, { autoClose: 2000 })
          : toast.error(data.data.message, { autoClose: 2000 });
        data.data.status
          ? dispatch({
              type: UPDATE_TERRITORY_SUCCESS,
              payload: { updateTerritory: data.data.status },
            })
          : dispatch({
              type: UPDATE_TERRITORY_FAIL,
              payload: { updateTerritory: data.data.status },
            });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({ type: UPDATE_TERRITORY_FAIL });
        dispatch({ type: SET_MESSAGE, payload: message });
        return Promise.reject();
      }
    )
    .catch((error) => {
      console.log(error);
    });
};
